<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
  <iTable
    :columns="columns"
    :loading="loading"
    :data="data"/>
</template>
<script>
import { keyBy, map, snakeCase, upperFirst } from 'lodash';
import { datetimeFormatter } from '@/utils/formatters';
import VersionDetail from './VersionDetails.vue';

export default {
  props: {
    config: { type: Object, required: true },
    versions: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  provide() {
    return { table: this };
  },
  computed: {
    attributesBy() {
      const { attributes } = this.config.resource;
      return keyBy(attributes, ({ prop, key }) => prop || key);
    },
    columns() {
      return [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => h(VersionDetail, {
            props: {
              version: params.row,
            },
          }),
        },
        {
          title: this.$t('models.attributes.version.created_at'),
          key: 'createdAt',
        },
        {
          title: this.$t('models.attributes.version.event'),
          key: 'event',
        },
        {
          title: this.$t('models.attributes.version.objectChanges'),
          key: 'changes',
        },
        {
          title: this.$t('models.attributes.version.user'),
          key: 'user',
        },
      ];
    },
    data() {
      return map(this.versions, version => ({
        ...version,
        createdAt: datetimeFormatter(version.createdAt),
        event: this.$t(`models.attributes.version.events.${version.event}`),
        changes: Object.keys(version.objectChanges).map(a => this.i18nAttr(a)).join(', '),
        user: version.user ? `${version.user.name} (${version.user.email})` : version.whodunnit,
      }));
    },
  },
  methods: {
    i18nAttr(key) {
      const { name, namespace } = this.config;
      const config = this.attributesBy[key];
      if (!config) return upperFirst(key);
      const snakedKey = snakeCase(config.key);

      const attr = ['models.attributes', ...namespace, name, snakedKey].join('.');
      if (this.$te(attr)) { return upperFirst(this.$t(attr)); }

      const i18n = ['models.attributes', snakedKey].join('.');
      if (this.$te(i18n)) { return upperFirst(this.$t(i18n)); }

      return upperFirst(key);
    },
  },
};
</script>
